import React, { Fragment, useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import MethodGet, {
  MethodDelete,
  MethodPost,
  MethodPut,
} from "../../Config/Services";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorIcon from "@material-ui/icons/Error";
import DoneIcon from "@material-ui/icons/Done";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { TextField, Grid, Button } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  couponInput: {
    width: "100%",
  },
  appliedChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    background: "#e8f5e9",
    color: "#2e7d32",
    padding: "6px 14px",
    borderRadius: 20,
    fontSize: "0.82rem",
    fontWeight: 600,
  },
}));

export default function DiscountCouponForm(props) {
  const classes = useStyles();

  const {
    saveCouponDiscount,
    disableCouponButton,
    saveCouponInfo,
    branch,
    couponDiscount,
  } = props;
  const [code, saveCode] = useState('');
  const onSubmit = (data, e) => {
    let url = `validateCouponSale?code=${code}&branch_id=${branch.id}`;
    MethodGet(url)
      .then((res) => {
        saveCouponDiscount(res.data.data.discount);
        saveCouponInfo(res.data.data);
        toast.success(
          <div>
            <DoneIcon /> Cupón Aplicado Exitosamente!{" "}
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      })
      .catch((error) => {
        toast.warn(
          <div>
            <ErrorIcon /> {error.response.data.error}{" "}
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        return;
      });
  };

  const { register, errors, handleSubmit } = useForm();

  return (
    <Fragment>
      {couponDiscount == "" ? (
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={8} md={9}>
            <TextField
              id="code"
              type="text"
              name="code"
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Código del cupón"
              onChange={(e) => {
                saveCode(e.target.value);
              }}
              inputRef={register({
                required: {
                  value: true,
                  message: "El Códígo es Requerido",
                },
              })}
            />
          </Grid>
          <Grid item xs={4} md={3}>
            <Button
              onClick={onSubmit}
              variant="contained"
              fullWidth
              size="small"
              style={{
                background: "#43a047",
                color: "#fff",
                borderRadius: 8,
                textTransform: "none",
                fontWeight: 600,
                padding: "7px 0",
              }}
            >
              Aplicar
            </Button>
          </Grid>
        </Grid>
      ) : (
        <div className={classes.appliedChip}>
          <CheckCircleIcon style={{ fontSize: 16 }} />
          Cupón Aplicado
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Fragment>
  );
}
